import React, { useEffect, useRef, useState } from 'react'
import FilterTabs from './partials/FilterTabs'
import Stats from './stats/Index'
import List from './list/Index'
import Servicing from './servicing/Index'
import { useHistory, useLocation } from 'react-router-dom'
import Types from './types/Index'
import TypesIndex from './TypesIndex'
import Dashboard from './dashboard/Index'
import Calendar from './calendar/Index'
import { fromInfo, trans } from '../../../_providers/Translation'
import Help from '../../partials/Help'
import ContractorServicing from './list/ContractorServicing'
import Contracts from '../../modules/contracts/Index'
import { CONTRACT_TYPES } from '../../modules/contracts/config'

function Contractors(props) {
    const location = useLocation()
    const history = useHistory()

    const searchParams = new URLSearchParams(location.search)

    const tabs = [
        {
            id: 'dashboard',
            name: trans('tabs.dashboard'),
            component: Dashboard,
        },
        {
            id: 'list',
            name: trans('tabs.list'),
            component: List,
            hasRef: true,
            help: <Help>{fromInfo('contractors.list')}</Help>
        },
        // {
        //     id: 'calendar',
        //     name: trans('tabs.calendar'),
        //     component: Calendar,
        //     hasRef: false
        // },
        {
            id: 'types',
            name: trans('tabs.types'),
            component: TypesIndex,
            hasRef: true,
            help: <Help>{fromInfo('contractors.types')}</Help>,
            props: {
                // only the companies module hides the inner tabs and keeps the
                // contractors list active
                hideTabs: true,
            },
        },
        {
            id: 'stats',
            name: trans('tabs.stats'),
            component: Stats,
            help: <Help>{fromInfo('contractors.stats')}</Help>
        },
        {
            id: 'servicing',
            name: trans('tabs.servicedDevices'),
            component: Servicing,
            // help: <Help>{fromInfo('contractors.stats')}</Help>
        },
        {
            id: 'contracts',
            name: trans('tabs.contracts'),
            component: Contracts,
            hasRef: true,
            props: {
                typeId: CONTRACT_TYPES.COMPANY,
            },
        },
    ]

    const tab = searchParams.get('tab') ? searchParams.get('tab') : tabs[0].id

    const componentRef = useRef(null)
    const servicingModalRef = useRef(null)

    const hasAddButton = searchParams.get('types') !== 'calendar'

    const hasAddServicingButton = searchParams.get('tab') === 'servicing'

    const [state, setState] = useState({
        tab: '',
        index: null,
        loading: true,
        data: null
    })

    const [refresh, setRefresh] = useState(0)

    const triggerRefresh = () => {
        setRefresh(prev => prev + 1)
    }

    useEffect(() => {

        setState(prev => ({
            ...prev,
            loading: true,
            tab: tab,
            index: findTabIndex(tab)
        }))

    }, [location.search])

    const handleTab = id => {

        let index = findTabIndex(id)

        setState(prev => ({
            ...prev,
            tab: id,
            index: index
        }))

        history.push('?tab=' + id)
    }

    const findTabIndex = id => {
        let index = tabs.findIndex(t => {
            return t.id === id
        })

        return index
    }

    const handleAdd = () => {
        let modal = componentRef.current

        if (modal) {
            modal.add()
        }
    }

    const handleAddInvoice = () => {
        history.push('/invoices/add')
    }

    const handleAddServicing = () => {
        servicingModalRef.current && servicingModalRef.current.open()
    }

    return (
        <div className="wrapper">
            <ContractorServicing
                ref={servicingModalRef}
                onSave={triggerRefresh}
            />

            <div className="top-part">
                <div className="left">
                    <h1 className="page-heading">
                        {trans('headings.contractors')}
                    </h1>
                    <p className="page-subheading">
                        {trans('subheadings.contractors')}
                    </p>
                </div>
                <div
                    className="right"
                    style={{
                        display: "flex"
                    }}
                >
                    <button className="button-add" onClick={handleAddInvoice}>
                        {trans('buttons.invoice')}
                    </button>
                    {tabs[state.index] && tabs[state.index].hasRef && hasAddButton
                        ?
                        <button
                            className="button-add"
                            onClick={handleAdd}
                            style={{
                                marginLeft: "8px"
                            }}
                        >
                            {trans('buttons.add')}
                        </button>
                        :
                        <>
                        </>
                    }
                    {hasAddServicingButton
                        ?
                        <button
                            className="button-add"
                            onClick={handleAddServicing}
                            style={{
                                marginLeft: "8px"
                            }}
                        >
                            {trans('buttons.add')}
                        </button>
                        :
                        <>
                        </>
                    }
                </div>
            </div>

            <FilterTabs
                tabs={tabs}
                tab={state.tab}
                handleTab={handleTab}
            />

            {tabs[state.index] &&
                React.createElement(tabs[state.index].component, {
                    key: `${tabs[state.index].id}-${refresh}`,
                    ref: componentRef,
                    ...(tabs[state.index].props || {})
                })
            }

        </div>
    )
}

export default Contractors